import { render } from "./lrbTable4.vue?vue&type=template&id=41112c62&scoped=true"
import script from "./lrbTable4.vue?vue&type=script&lang=js"
export * from "./lrbTable4.vue?vue&type=script&lang=js"

import "./lrbTable4.vue?vue&type=style&index=0&id=41112c62&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41112c62"]])

export default __exports__